import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

const LayoutHeader = ({ header, children, footer, imageBackground, textInImageBackground, courseGradient, className, style }) => {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(null);

  useEffect(() => {
    if (!header || !headerRef.current || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const updateHeaderHeight = () => setHeaderHeight(headerRef.current.offsetHeight);
    updateHeaderHeight();

    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(headerRef.current);

    return () => resizeObserver.disconnect();
  }, [header]);

  const layoutHeaderStyle = {
    ...style,
    ...(headerHeight !== null && { '--layout-header-height': `${headerHeight}px` }),
  };

  return (
    <div className={clsx('layout-header', className, { 'layout-header--with-footer': footer })} style={layoutHeaderStyle}>
      {header && (
        <div ref={headerRef} className="layout-header__header">
          {header}
        </div>
      )}
      {(imageBackground || courseGradient) && (
        <div className="layout-header__background-image" style={{ backgroundImage: imageBackground ? `url(${imageBackground})` : courseGradient }}>
          <div className="layout-header__background-text-container">
            <span className="layout-header__background-text">{textInImageBackground}</span>
          </div>
        </div>
      )}
      <div className="layout-header__content" id="layout-header__content">
        <div className="layout-header__children">{children}</div>
      </div>
      {footer && <div className="layout-header__footer">{footer}</div>}
    </div>
  );
};

LayoutHeader.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  imageBackground: PropTypes.string,
  textInImageBackground: PropTypes.node,
  courseGradient: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default LayoutHeader;
